export const environment = {
  production: true,
  configurationFiles: [
    '/ncis-assets/data/settings/appsettings.json',
    '/ncis-assets/data/settings/appsettings.production.json',
  ],
};
